import { useState, useCallback } from 'react';

const useLoadingState = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Caricamento in corso...');
  const [loadingType, setLoadingType] = useState('default'); // default, primary, success, warning, error

  const startLoading = useCallback((message = 'Caricamento in corso...', type = 'default') => {
    setIsLoading(true);
    setLoadingMessage(message);
    setLoadingType(type);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
    setLoadingMessage('Caricamento in corso...');
    setLoadingType('default');
  }, []);

  const setLoadingError = useCallback((message = 'Errore durante il caricamento') => {
    setLoadingType('error');
    setLoadingMessage(message);
  }, []);

  const setLoadingSuccess = useCallback((message = 'Operazione completata con successo') => {
    setLoadingType('success');
    setLoadingMessage(message);
  }, []);

  const setLoadingWarning = useCallback((message = 'Attenzione') => {
    setLoadingType('warning');
    setLoadingMessage(message);
  }, []);

  return {
    isLoading,
    loadingMessage,
    loadingType,
    startLoading,
    stopLoading,
    setLoadingError,
    setLoadingSuccess,
    setLoadingWarning
  };
};

export default useLoadingState; 